import { render, staticRenderFns } from "./Badge.vue?vue&type=template&id=66371fd2&"
import script from "./Badge.vue?vue&type=script&lang=js&"
export * from "./Badge.vue?vue&type=script&lang=js&"
import style0 from "./Badge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports